import React from 'react'
import {FaBookOpen} from "react-icons/fa"

export default function Heading() {
    return (
        <div className="heading">
            <h1><FaBookOpen/>Book Recommendation</h1>
            <p>Its my pesonal choice</p>
        </div>
    )
}
